import { postApi, getApi, putApi } from "../services/axios";
import APIs from ".";

export function getAppSettings() {
  return async function (dispatch) {
    const res = await getApi(APIs.APP_SETTINGS.GET_SETTINGS);
    return res;
  };
}

export function updateAppSettings(payload: any) {
  return async function (dispatch) {
    const res = await putApi(APIs.APP_SETTINGS.UPDATE_SETTINGS, payload);
    return res;
  };
}

export function flushRedisCache() {
  return async function () {
    const res = await postApi(APIs.APP_SETTINGS.FLUSH_REDIS, {}, {
      validateUser: true,
    });
    return res;
  };
}
